import React from "react";
import DataConfig from './_config.json'
import axios from 'axios';

var Token = localStorage.getItem('Token');
var defaultCMP = localStorage.getItem("company");
var defaultUsername = localStorage.getItem("Username");

// var HiEasyToken = localStorage.getItem("TokenHieasy");
// var HiEasyUsername = localStorage.getItem("UsernameHieasy");

// export const LoadJson = (SJob,Parameter) =>{
//     var json = [];
//     var url ="https://psmdapi.pspl.co.th/CSRIGHT/MainMenu?api_key=JmeD3lEvTKVOp0pKPJwHsbGKGDAdZlo5cwbrhsYc&jwt="+localStorage.getItem('Token')+"&user="+localStorage.getItem('Username')+"";
//     axios.get(url).then(
//         res =>{
//             json = res.data
//         }
//     )
//     // return url;
// }
export const getdomain = () => {
    return window.location.hostname;
}
export const CSLogin = (company) => {
    console.log("company", company);
    var hostname = DataConfig[company + "hostname"];
    var service = DataConfig.CSLogin[company].service;
    var job = DataConfig.CSLogin[company].job[0];
    var api_key = DataConfig.CSLogin[company].api_key;
    var url = hostname + service + "/" + job + "?api_key=" + api_key;
    return url;
}

export const ICSPSTax = (company, job, value) => {
    var url = "";
    var hostname = DataConfig[company + "hostname"];
    var service = DataConfig.ICSPSTax[company].service;
    var jobTxt = DataConfig.ICSPSTax[company].job[job];
    var api_key = DataConfig.ICSPSTax[company].api_key;
    switch (job) {
        case 0: url = hostname + service + "/" + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + "&saleno=" + value;
            break;
        case 1: url = hostname + service + "/" + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + "&saledate=" + value;
            break;
        case 2:
        case 3: url = hostname + service + "/" + jobTxt + "?api_key=" + api_key + "&jwt=" + Token;
            break;
        // case 3: url = "http://192.168.1.202:8080/Sale?api_key=SEmWCvRhzqc1VwPUjLLmkrAWBgwKj3z8h7xzb6MK&jwt="+Token;
        // break;
    }
    return url;
}

export const hisaleno = (value, company) => {
    var cmp;
    if (company) {
        cmp = company
    } else {
        cmp = defaultCMP;
    }
    var hostname = DataConfig.hisaleno.hostname;
    var service = DataConfig.hisaleno.service;
    var jobTxt = DataConfig.hisaleno.job;
    var api_key = DataConfig.hisaleno.api_key;
    var url = hostname + service + jobTxt + '?api_key=' + api_key +
        '&stockdate1=' + value +
        '&stockdate2=' + value +
        '&stocktype=' + "HP" +
        '&company=' + cmp;
    return url;
}

export const CSHome = (job) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSHome[defaultCMP].service;
    var jobTxt = DataConfig.CSHome[defaultCMP].job[job];
    var api_key = DataConfig.CSHome[defaultCMP].api_key;
    url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername;
    console.log("CSHome", url);
    return url;
}

export const CSAR = (job, value) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSAR.service;
    var jobTxt = DataConfig.CSAR.job[job];
    var api_key = DataConfig.API_KEY[defaultCMP];
    switch (job) {
        case 0: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + "&arname=" + value;
            break;
    }
    return url;
}

export const CSProduct = (job, value) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSProduct.service;
    var jobTxt = DataConfig.CSProduct.job[job];
    var api_key = DataConfig.API_KEY[defaultCMP];
    switch (job) {
        case 0: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + "&code=" + value;
            break;
    }
    return url;
}

export const CSSite = (job, value) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSSite.service;
    var jobTxt = DataConfig.CSSite.job[job];
    var api_key = DataConfig.API_KEY[defaultCMP];
    url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + "&code=";
    return url;
}

export const CSAllocate = (job, value) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSAllocate.service;
    var jobTxt = DataConfig.CSAllocate.job[job];
    var api_key = DataConfig.API_KEY[defaultCMP];
    url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + "&code=";
    return url;
}

export const CSOrderBook = (job, value) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSOrderBook[defaultCMP].service;
    var jobTxt = DataConfig.CSOrderBook[defaultCMP].job[job];
    var api_key = DataConfig.CSOrderBook[defaultCMP].api_key;
    switch (job) {
        case 0: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&item=" + value; break;
        case 1: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&item=" + value; break;
        case 2: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&txt=" + value; break;
        case 3: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token; break;
    }
    return url;
}
export const CSDocGroup = (job, value) => {
    var url = "";
    var hostname = DataConfig[defaultCMP + "hostname"];
    var service = DataConfig.CSDocGroup.service;
    var jobTxt = DataConfig.CSDocGroup.job[job];
    var api_key = DataConfig.API_KEY[defaultCMP];
    var Parameter = "&code=" + value + "&table=CSSALE";
    switch (job) {
        case 0: url = hostname + service + '/' + jobTxt + "?api_key=" + api_key + "&jwt=" + Token + "&user=" + defaultUsername + Parameter;
            break;
    }
    return url;
}
export const GetChassisno = (value, job, data1) => {
    var hostname = DataConfig.StockItem.hostname;
    var service = DataConfig.StockItem.service;
    var job = DataConfig.StockItem.job[job];
    var apikey = "?api_key=" + DataConfig.StockItem.api_key;
    var parameter = "&chassisno=" + value;
    var url = hostname + service + job + apikey + parameter + "&condition=" + data1;
    return url;
}

export default class Index extends React.Component { }